import React, { useState } from "react";
import { X, Search } from "lucide-react";
import useStore from "../../store/useStore";

const SearchModal = ({ products = [], onViewProduct }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const isOpen = useStore((state) => state.searchOpen);
  const setSearchOpen = useStore((state) => state.setSearchOpen);

  const searchResults =
    searchQuery.length > 0
      ? products.filter((product) =>
          [product.name, product.sku, product.gender, product.description]
            .filter(Boolean)
            .some((field) =>
              field.toLowerCase().includes(searchQuery.toLowerCase())
            )
        )
      : [];

  const handleClose = () => {
    setSearchOpen(false);
    setSearchQuery("");
  };

  const handleProductClick = (product) => {
    onViewProduct(product);
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleClose}
      />
      <div className="absolute top-0 left-0 right-0 bg-white shadow-2xl">
        <div className="max-w-4xl mx-auto p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="flex-1 relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search for jewelry..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoFocus
                className="w-full pl-12 pr-4 py-4 border-2 border-gray-300 rounded-full focus:outline-none focus:border-[#d4af37] text-lg"
              />
            </div>
            <button
              onClick={handleClose}
              className="p-3 hover:bg-gray-100 rounded-full transition"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {searchQuery.length > 0 && (
            <div className="max-h-96 overflow-y-auto">
              {searchResults.length > 0 ? (
                <div className="space-y-3">
                  {searchResults.map((product) => (
                    <button
                      key={product.id}
                      onClick={() => handleProductClick(product)}
                      className="w-full flex items-center gap-4 p-4 hover:bg-gray-50 rounded-xl transition text-left"
                    >
                      <img
                        src={product.tinyThumbs?.[0] || product.images[0]}
                        alt={product.name}
                        className="w-16 h-16 object-cover rounded-lg"
                      />
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-900">
                          {product.name}
                        </h4>
                        <p className="text-sm text-gray-500">
                          {product.gender}
                        </p>
                      </div>
                      <span className="text-lg font-bold text-gray-900">
                        ${product.price.toLocaleString()}
                      </span>
                    </button>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <p className="text-gray-500">
                    No products found for "{searchQuery}"
                  </p>
                </div>
              )}
            </div>
          )}

          {searchQuery.length === 0 && (
            <div className="text-center py-12">
              <Search className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">
                Start typing to search for products...
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchModal;
